import { FC, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AuthFormAction } from 'components/forms/auth/layout';
import TextInput from 'components/inputs/text';
import { Button } from 'components/button/Button';
import { ResendVerification } from 'components/forms/auth/ResendVerification';
import { ReactComponent as Back } from 'assets/icons/arrow-left-circle.svg';
import { verifyUserApi, resendVerificationApi } from 'api/apiRequest';
import errorHandler from 'handlers/errorHandler';

export const ResendOtpPage: FC = () => {
	const navigate = useNavigate();
	const [data, setData] = useState('');
	const [getCode, setGetCode] = useState(true);
	const [defaultTimer, setDefaultTimer] = useState(false);
	const { email } = useSelector((state: any) => state.authReducer);

	const { isLoading, mutate } = useMutation(verifyUserApi, {
		onError: (error: Error) => {
			errorHandler(error, true);
		},
		onSuccess: () => {
			navigate('/auth/login');
		},
		retry: 0,
	});

	const { mutate: getCodeMutate } = useMutation(resendVerificationApi, {
		onError: (error: Error) => {
			errorHandler(error, true);
		},
		onSuccess: (res: any) => {
			toast.success(res?.message, {
				position: toast.POSITION.TOP_RIGHT,
				theme: 'colored',
				autoClose: 6000,
			});
			setDefaultTimer(true);
			setGetCode(false);
		},
		retry: 0,
	});

	const onSubmit = () => {
		const formData = {
			email: email,
			otp: data,
		};
		mutate(formData);
	};

	return (
		<div className="lg:grid grid-cols-1 items-center gap-5 text-white px-0 sm:px-4">
			<div className="flex gap-2 items-center mb-8">
				<Back
					className="w-[34px] h-[34px] cursor-pointer"
					onClick={() => navigate(-1)}
					data-testid="back-to-homepage"
				/>
				<h3 className="text-2xl font-bold">Verify Email</h3>
			</div>
			<AuthFormAction>
				<p className="font-medium text-grey">
					Please enter the security verification code sent to your email
				</p>
				<p className="mb-10 font-medium text-green">{email}</p>
				<TextInput
					type={'number'}
					label={'Enter verification code'}
					onChange={(e) => setData(e.target.value)}
				/>
				{getCode && (
					<button
						data-testid="verification-code"
						className="mb5 mt2 text-bold text-green text-right"
						type="button"
						onClick={() =>
							getCodeMutate({
								email: email,
							})
						}
					>
						Get Code Now
					</button>
				)}

				<Button
					text={'Verify Email'}
					loading={isLoading}
					data-testid="resend-email-verification-button"
					className={
						'text-[15px] text-black font-bold btn-primary h-[56px] rounded-full mb-3 mt-5 justify-center block w-full px-8'
					}
					onClick={() => onSubmit()}
				/>

				<ResendVerification defaultTimer={defaultTimer} />
			</AuthFormAction>
		</div>
	);
};
